import React, {setState, useRef, useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import styles from "./Invoices.module.css";
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import PropTypes from 'prop-types';
import { makeStyles, useTheme, alpha } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container'
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import { useSnackbar } from 'react-simple-snackbar'
import {DataGrid, GridToolbar, GridCellEditStopReasons, GridComparatorFn, DEFAULT_GRID_AUTOSIZE_OPTIONS} from "@mui/x-data-grid";
import axios from 'axios';
import ProgressButton from 'react-progress-button'
import { deleteInvoice } from '../../actions/invoiceActions';
import { useLocation } from 'react-router-dom';
import useAuthUser from '../../hooks/useAuthUser'
import { fetchInvoiceList, fetchInvoicePrintRows } from '../../api';

import NoData from '../svgIcons/NoData';
import Spinner from '../Spinner/Spinner'


import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { getVisibleRows } from '@mui/x-data-grid/internals';

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),

  },
}));

const useStyles2 = makeStyles(theme => ({
  table: {
    minWidth: 500,
    
  },

  tablecell: {
    fontSize: '16px'
}
}));

const tableStyle = { width: 160, fontSize: 14, cursor: 'pointer', borderBottom: 'none',  padding: '8px', textAlign: 'center' }
const headerStyle = { borderBottom: 'none', textAlign: 'center'}

const INVOICE_GRID_STATE_KEY = 'wholesaleUsaInvoiceGridState:v2';
const DEFAULT_INVOICE_GRID_STATE = {
  filterModel: { items: [] },
  sortModel: [{ field: 'receivedByDate', sort: 'desc' }],
  paginationModel: { page: 0, pageSize: 50 },
};

const readInvoiceGridState = () => {
  try {
    const stored = window.sessionStorage.getItem(INVOICE_GRID_STATE_KEY);
    if (!stored) return DEFAULT_INVOICE_GRID_STATE;
    const parsed = JSON.parse(stored);
    return {
      filterModel: parsed?.filterModel || DEFAULT_INVOICE_GRID_STATE.filterModel,
      sortModel: Array.isArray(parsed?.sortModel) ? parsed.sortModel : DEFAULT_INVOICE_GRID_STATE.sortModel,
      paginationModel: parsed?.paginationModel || DEFAULT_INVOICE_GRID_STATE.paginationModel,
    };
  } catch {
    return DEFAULT_INVOICE_GRID_STATE;
  }
};


const Invoices = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const authData = useAuthUser()
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [clientOptions, setClientOptions] = useState([]);
  const [todayBoundaryInvoiceId, setTodayBoundaryInvoiceId] = useState('');
  const [listLoading, setListLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const isLoading = listLoading;
        // eslint-disable-next-line 
  const [openSnackbar, closeSnackbar] = useSnackbar()
  const [downloadStatus, setDownloadStatus] = useState('disabled')
  const [downloadTdStatus, setDownloadTdStatus] = useState('')
  const [gridState, setGridState] = React.useState(readInvoiceGridState);
  const statuses = ['Unpaid', 'Paid', 'Partial']
  const clientArray = React.useMemo(() => {
    if (clientOptions.length) return clientOptions;
    return [...new Set((rows || []).map((invoice) => invoice?.client?.store).filter(Boolean))].sort();
  }, [clientOptions, rows]);

  const formatDollarsToCents = function (value) {
    value = `${value}`.replace(/[^\d.-]/g, '');
    if (value && value.includes('.')) {
        value = value.substring(0, value.indexOf('.') + 3);
    }
  
    return value ? Math.round(parseFloat(value) * 100) : 0;
  };
  
  const formatCentsToDollars = function (value) {
    value = `${value}`.replace(/[^\d.-]/g, '');
    value = parseFloat(value);
    return value ? value / 100 : 0;
  };

  // Create our number formatter.
const dollar_formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
});

  const displayAsDollars = function(params) {
    return dollar_formatter.format(formatCentsToDollars(params))
  }




  // const rows = []


    // useEffect(() => {
    //     dispatch(getInvoices());
    // }, [dispatch]);

    useEffect(() => {
      let cancelled = false;
      setListLoading(true);
      fetchInvoiceList({
        page: gridState.paginationModel?.page || 0,
        pageSize: gridState.paginationModel?.pageSize || 20,
        filters: gridState.filterModel?.items || [],
        sortModel: gridState.sortModel || [],
      })
        .then(({ data }) => {
          if (cancelled) return;
          setRows(data?.data || []);
          setRowCount(Number(data?.total || 0));
          setClientOptions(data?.clientOptions || []);
          setTodayBoundaryInvoiceId(data?.todayBoundaryInvoiceId || '');
        })
        .catch((error) => {
          console.log(error?.response || error);
          if (!cancelled) {
            setRows([]);
            setRowCount(0);
          }
        })
        .finally(() => {
          if (!cancelled) setListLoading(false);
        });
      return () => {
        cancelled = true;
      };
    }, [gridState.filterModel, gridState.paginationModel, gridState.sortModel, refreshKey]);

    const updateGridState = React.useCallback((updater) => {
      setGridState((prev) => {
        const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater };
        try {
          window.sessionStorage.setItem(INVOICE_GRID_STATE_KEY, JSON.stringify(next));
        } catch {
          // Ignore storage failures so the grid remains usable.
        }
        return next;
      });
    }, []);

    useEffect(() => {
      const filterItems = gridState.filterModel?.items || [];
      const receivedDateFilter = filterItems.find(
        (item) => item.field === 'receivedByDate' && item.value !== undefined && item.value !== ''
      );

      setDownloadStatus(receivedDateFilter ? '' : 'disabled');
    }, [gridState.filterModel])

   const toCommas = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rows.length);
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  // const handleDateChange = (value) => {
  //   if (value !== null) {
  //     let val = moment(value).format('MM/DD/yyyy');
  //     setSelectedDate(val);
  //     const filteredRows = invoices.filter((row) => {
  //       if (moment(row.receivedByDate).format('MM/DD/yyyy').includes(val)) {
  //         return true;
  //       }
  //       return false;
  //     });
  //     if (filteredRows.length > 0) {
  //       setDownloadStatus('')
  //     }
  //     setRows(filteredRows);
  //   } else {
  //     //setDownloadStatus('disabled')
  //     setRows(invoices);
  //   }
  // }


  // Print Invoices
  const printInvoices = async () => {
    if (downloadStatus === 'disabled') return;
    try {
      setDownloadStatus('loading')
      const { data } = await fetchInvoicePrintRows({
        filters: gridState.filterModel?.items || [],
        sortModel: gridState.sortModel || [],
      });
      const printRows = data?.data || [];
      if (printRows.length === 0) {
        setDownloadStatus('error')
        return
      }
      let pdfList = printRows.map(row => {
        //Get the total amount paid
        let totalAmountReceived = 0
        for(var i = 0; i < row?.paymentRecords?.length; i++) {
            totalAmountReceived += Number(row?.paymentRecords[i]?.amountPaid)
        }
        return { name: row.client.name,
          store: row.client.store,
          address: row.client.address,
          phone: row.client.cellPhone,
          email: row.client.email,
          dueDate: row.dueDate,
          receivedByDate: row.receivedByDate,
          date: row.createdAt,
          id: row.rowNumber,
          notes: row.notes,
          subTotal: toCommas(row.subTotal),
          total: toCommas(row.total),
          type: row.type,
          salesTax: row.salesTax,
          deliveryFee: row.deliveryFee,
          items: row.items,
          status: row.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(row.total - totalAmountReceived),
          paymentRecords: row.paymentRecords,
      }
      })
      axios.post(`${process.env.REACT_APP_API}/pdfs/create-pdf-landscape`, 
      { pdfDate : '', pdfList }
      , {responseType: 'blob'})
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(pdfBlob);
          //Open the URL on new Window
           const pdfWindow = window.open();
           pdfWindow.location.href = fileURL;  
          // saveAs(pdfBlob, 'invoice.pdf')
        }).then(() =>  setDownloadStatus('success'))
    } catch (error) {
      console.log(error?.response || error)
      setDownloadStatus('error')
    }
   }

   // Print Invoices
  const printTdInvoices = async () => {
    try {
      setDownloadTdStatus('loading')
      const { data } = await fetchInvoicePrintRows({
        today: true,
        sortModel: gridState.sortModel || [],
      });
      const printRows = data?.data || [];
      if (printRows.length === 0) {
        setDownloadTdStatus('error')
        return
      }
      let pdfList = printRows.map(row => {
        //Get the total amount paid
        let totalAmountReceived = 0
        for(var i = 0; i < row?.paymentRecords?.length; i++) {
            totalAmountReceived += Number(row?.paymentRecords[i]?.amountPaid)
        }
        return { name: row.client.name,
          store: row.client.store,
          address: row.client.address,
          phone: row.client.cellPhone,
          email: row.client.email,
          dueDate: row.dueDate,
          receivedByDate: row.receivedByDate,
          date: row.createdAt,
          id: row.rowNumber,
          notes: row.notes,
          subTotal: toCommas(row.subTotal),
          total: toCommas(row.total),
          type: row.type,
          salesTax: row.salesTax,
          deliveryFee: row.deliveryFee,
          items: row.items,
          status: row.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(row.total - totalAmountReceived),
          paymentRecords: row.paymentRecords,
      }
      })
      axios.post(`${process.env.REACT_APP_API}/pdfs/create-pdf-landscape`, 
      { pdfDate : '', pdfList }
      , {responseType: 'blob'})
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(pdfBlob);
          //Open the URL on new Window
           const pdfWindow = window.open();
           pdfWindow.location.href = fileURL;  
          // saveAs(pdfBlob, 'invoice.pdf')
        }).then(() =>  setDownloadTdStatus('success'))
    } catch (error) {
      console.log(error?.response || error)
      setDownloadTdStatus('error')
    }
   }


  const riskyInvoiceIds = React.useMemo(() => {
    const riskySet = new Set();
    const resolvedSet = new Set();
    (rows || []).forEach(inv => {
      const hasRiskyItem = (inv?.items || []).some(item => {
        const unitCost = parseFloat(item?.unitCost) || 0;
        const unitPrice = parseFloat(item?.unitPrice) || 0;
        return unitCost > unitPrice;
      });
      if (hasRiskyItem) {
        const id = String(inv?._id || '');
        if (!id) return;
        if (inv?.flaggedResolved) resolvedSet.add(id);
        else riskySet.add(id);
      }
    });
    return { riskySet, resolvedSet };
  }, [rows]);

  const columns = [
    {
      field: 'client',
      headerName: 'Client',
       type: 'singleSelect',
      valueOptions: clientArray,
      editable: false,
      minWidth: 125,
      flex: 1,
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        const valueFormatted = params.value.store;
        return valueFormatted;
      }, 
    },
    { 
      field: 'total', 
      headerName: 'Amount', 
      editable: false,
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        const valueFormatted = '$' + toCommas(params.value);
        return valueFormatted;
      },
    },
    { 
      flex: 1,
      minWidth: 150,
      field: 'receivedByDate', 
      headerName: 'Received Date',
      editable: false,
      type: 'date',
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        // const valueFormatted = moment(params.value).format('MM/DD/yyyy');
        // return valueFormatted;
        const valueFormatted = new Date(params.value);
        return valueFormatted;
      },
    },
    { 
      flex: 1,
      minWidth: 150,
      field: 'dueDate', 
      headerName: 'Due Date', 
      editable: false,
      type: 'date',
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        // const valueFormatted = moment(params.value).format('MM/DD/yyyy');
        // return valueFormatted;
        const valueFormatted = new Date(params.value);
        return valueFormatted;
      },
    },
    { field: 'status',
      type: 'singleSelect',
      valueOptions: statuses,
       headerName: 'Status',
       width: 125,  
       renderCell: (params) => {
      return (
        <button style={checkStatus(params.value)}>{params.value}</button>
      );
    } },
    { field: 'actions', headerName: 'Actions', headerAlign: 'center', align: 'center', flex:1, minWidth: 200, renderCell: (params) => {
      return (
        <div style={{display: 'flex'}}>
          <Button
            style={{color: 'white', backgroundColor: 'rgb(25, 118, 210)', marginRight: 10}}
            onClick={() => editInvoice(params.row._id)}
            variant="contained"
          >
            Edit
          </Button>
          <Button
            style={{color: 'white', backgroundColor: 'red'}}
            onClick={(e) => {
              e.stopPropagation();
              setDeleteTargetId(params.row._id);
            }}
            variant="contained"
          >
            Delete
          </Button>
            
  
        </div>
        
      );
    } }
  ];

  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`)
  }

  const openInvoice = (id) => {
    history.push(`/invoice/${id}`)
  }

  const handleCancelDelete = () => setDeleteTargetId(null);
  const handleConfirmDelete = async () => {
    if (deleteTargetId) {
      await dispatch(deleteInvoice(deleteTargetId, openSnackbar));
      setRefreshKey((value) => value + 1);
    }
    setDeleteTargetId(null);
  };

  const hasActiveGridFilters = React.useMemo(() => (
    (gridState.filterModel?.items || []).some((item) => item?.value !== undefined && item?.value !== null && item?.value !== '')
  ), [gridState.filterModel]);

  if(!authData) {
    history.push('/login')
  }



  function checkStatus(status) {
    return status === "Partial" ? {border: 'solid 0px #1976d2', backgroundColor: '#baddff', padding: '8px 18px', borderRadius: '20px' }
        : status === "Paid" ? {border: 'solid 0px green', backgroundColor: '#a5ffcd', padding: '8px 18px', borderRadius: '20px' }
        : status === "Unpaid" ? {border: 'solid 0px red', backgroundColor: '#ffaa91', padding: '8px 18px', borderRadius: '20px' }
        : "red";
          
}

  if(isLoading) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px'}}>
        <Spinner />
    </div>
  }

  if(!isLoading && rows.length === 0 && rowCount === 0 && !hasActiveGridFilters) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px', margin: '80px'}}>
      <NoData />
    <p style={{padding: '40px', color: 'gray', textAlign: 'center'}}>No invoice yet. Click the plus icon to create invoice</p>
  
    </div>
  }
  
  return (
    <div className={styles.pageLayout}>
      <Dialog open={Boolean(deleteTargetId)} onClose={handleCancelDelete}>
        <DialogTitle>Delete Invoice</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this invoice? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Container style={{maxWidth: 1600}}>
        <div className={styles.buttons}>
        <h1 style={{paddingTop: 10}}>Invoices</h1>
          <ProgressButton 
            style={{width: 100}}
            onClick={printInvoices} 
            state={downloadStatus}>
            Print All
          </ProgressButton>
          <ProgressButton 
            style={{width: 100}}
            onClick={printTdInvoices} 
            state={downloadTdStatus}>
            Print Today
          </ProgressButton>
        </div>
        <div className={styles.gridLayout}>
              <DataGrid
              sx={{
                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '8px' },
                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '12px' },
              }}
                autoHeight
                rows={rows}
                getRowId={(row) => row._id}
                getRowHeight={() => 'auto'}
                columns={columns}
                loading={listLoading}
                rowCount={rowCount}
                paginationMode="server"
                sortingMode="server"
                filterMode="server"
                filterModel={gridState.filterModel}
                onFilterModelChange={(filterModel) => {
                  updateGridState((prev) => ({
                    ...prev,
                    filterModel,
                    paginationModel: { ...prev.paginationModel, page: 0 },
                  }));
                }}
                sortModel={gridState.sortModel}
                onSortModelChange={(sortModel) => updateGridState({ sortModel })}
                paginationModel={gridState.paginationModel}
                onPaginationModelChange={(paginationModel) => updateGridState({ paginationModel })}
                pageSizeOptions={[20, 50, 100]}
                components={{
                  Toolbar: GridToolbar,
                }}
                onRowClick={(row) => openInvoice(row.id)}
                sortingOrder={['desc','asc']}
                getRowClassName={(params) => {
                  const rowId = String(params.id || '');
                  const classNames = [];
                  if (rowId === String(todayBoundaryInvoiceId || '')) classNames.push(styles.todayBoundaryRow);
                  if (riskyInvoiceIds.resolvedSet.has(rowId)) classNames.push(styles.costWarningResolvedRow);
                  if (riskyInvoiceIds.riskySet.has(rowId)) classNames.push(styles.costWarningRow);
                  return classNames.join(' ');
                }}
              />
          </div>
      </Container>
    </div>
  
  );
}

export default Invoices
